<div
  #viewer
  class="viewer"
  [ngClass]="viewPortMode ? 'fullScreenViewPort' : ''"></div>
